export default "__VITE_PUBLIC_ASSET__243419c9__"